/**
 * Exotics Adventure bootstrap - Lane 3 UI shell (replaces the scaffold stub).
 * Lane 2 mounts its renderer into #world-canvas-host and listens for the
 * 'ea:camera' CustomEvent (see src/ui/input/touch.ts). Lane 1's worker replaces
 * the stub bridge in src/ui/bridge.ts.
 */
import { h, render } from "preact";
import { App } from "./ui/App";
import "./styles/ui.css";
import { startUpdateWatch } from "./pwaUpdate";

const app = document.getElementById("app");
if (app) {
  render(h(App, null), app);
}
startUpdateWatch();

export {};
